export default window.__litium.constants;

export const ViewMode = {
    List: 'list',
    Edit: 'edit',
    Detail: 'detail',
};

export const PaginationOptions = {
    PageSize: 5, // Number of items per page
    DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
    EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where "1 2 3" and "97 98 99" are edge entries
};

export const AddressTypeNameConstants = {
    Address: 'Address',
    AlternativeAddress: 'AlternativeAddress',
    Billing: 'Billing',
    Delivery: 'Delivery',
    BillingAndDelivery: 'BillingAndDelivery',
};

export const ProductQuantityConstants = {
    ProductDetailQuantityButton: 'product-detail__quantity-button',
    ProductDetailQuantityInput: 'product-detail__quantity-input',
    MinusSign: '-',
    PlusSign: '+',
    QuantityId: 'quantityForCart',
};

export const PaymentIntegrationType = {
    IframeCheckout: 'IframeCheckout',
    PaymentWidgets: 'PaymentWidgets',
    DirectPayment: 'DirectPayment',
};

export const ShippingIntegrationType = {
    Inline: 'Inline',
    DeliveryCheckout: 'DeliveryCheckout',
    PaymentCheckout: 'PaymentCheckout',
};

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_UPDATE_QUANTITY = 'CART_UPDATE_QUANTITY';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS =
    'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_SHIPPING = 'CHECKOUT_SET_SHIPPING';
export const CHECKOUT_SET_ADDITIONALDATA = 'CHECKOUT_SET_ADDITIONALDATA';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_USED_DISCOUNT_CODE =
    'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION =
    'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SET_SHIPMENT_WIDGET = 'CHECKOUT_SET_SHIPMENT_WIDGET';
export const CHECKOUT_SET_PAYMENTUPDATING = 'CHECKOUT_SET_PAYMENTUPDATING';
export const CHECKOUT_UPDATE_CUSTOMER_INFO = 'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS =
    'CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON =
    'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CHECKOUT_VALIDATE_ADDRESS = 'CHECKOUT_VALIDATE_ADDRESS';
export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';

export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT = 'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';

export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE =
    'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';

export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW_FULL_FORM = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';

export const ORDER_RECEIVE = 'ORDER_RECEIVE';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CHANGE_MODE = 'ORDER_CHANGE_MODE';
export const ORDER_CHANGE_CURRENTPAGE = 'ORDER_CHANGE_CURRENTPAGE';
export const ORDER_SET_ORDER = 'ORDER_SET_ORDER';

export const NEWSLETTER_RECEIVE = 'NEWSLETTER_RECEIVE';
export const NEWSLETTER_SUBMIT_ERROR = 'NEWSLETTER_SUBMIT_ERROR';
export const NEWSLETTER_SUBMIT_DONE = 'NEWSLETTER_SUBMIT_DONE';
export const NEWSLETTER_SUBMIT_SUBSCRIPTION = 'NEWSLETTER_SUBMIT_SUBSCRIPTION';

export const ADVERTISE_EMAIL_RECEIVE = 'ADVERTISE_EMAIL_RECEIVE';
export const PRODUCT_EMAIL_RECEIVE = 'PRODUCT_EMAIL_RECEIVE';
export const PRODUCT_EMAIL_ERROR = 'PRODUCT_EMAIL_ERROR';
export const MAIL_LOADING = 'MAIL_LOADING';

export const CHECKOUT_SET_DISABLED_STATUS = 'CHECKOUT_SET_DISABLED_STATUS';
export const CHECKOUT_SET_BILLING_AS_DELIVERY =
    'CHECKOUT_SET_BILLING_AS_DELIVERY';
export const CHECK_IF_USER_EXISTS = 'CHECK_IF_USER_EXISTS';

export const WISHLIST_UPDATE_WISHLIST_NAME = 'WISHLIST_UPDATE_WISHLIST_NAME';
export const WISHLIST_ADD = 'WISHLIST_ADD';
export const WISHLIST_ADD_ALL_TO_LIST_MESSAGE =
    'WISHLIST_ADD_ALL_TO_LIST_MESSAGE';
export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';
export const WISHLIST_ADD_ALL_TO_CART = 'WISHLIST_ADD_ALL_TO_CART';
export const WISHLIST_GET = 'WISHLIST_GET';
export const WISHLIST_GET_LINK = 'WISHLIST_GET_LINK';
export const WISHLIST_GET_ALL = 'WISHLIST_GET_ALL';
export const WISHLIST_GET_SUMMARY = 'WISHLIST_GET_SUMMARY';
export const WISHLIST_DELETE = 'WISHLIST_DELETE';
export const WISHLIST_DELETE_ITEM = 'WISHLIST_DELETE_ITEM';
export const WISHLIST_SET_ACTIVE = 'WISHLIST_SET_ACTIVE';
export const WISHLIST_SHOW_ACTIVE = 'WISHLIST_SHOW_ACTIVE';
export const WISHLIST_SET_PAGE = 'WISHLIST_SET_PAGE';
export const WISHLIST_SET_INCLUDED_IN_WISHLISTS =
    'WISHLIST_SET_INCLUDED_IN_WISHLISTS';
export const WISHLIST_SET_IN_WISHLIST = 'WISHLIST_SET_IN_WISHLIST';
export const WISHLIST_ADD_SHARED = 'WISHLIST_ADD_SHARED';

export const REMOVE_ERROR = 'REMOVE_ERROR';
